import { ButtonMoreOptions, Card, Chips, ItemStatus } from 'components';
import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { ProductsDetailsView } from 'shared/services/user-subscription';
import { PaymentGatewayLink } from '../PaymentGatewayLink/PaymentGatewayLink';
import './Item-product.scss';

interface ItemProductProps {
  userProductIdPublic: string;
  products: ProductsDetailsView[];
  productId: number;
  productTitle: string;
  price: number;
  quantity: number;
  status: 'successful' | 'error' | 'pending';
  customerStripeId: string;
  providerProcessor: string;
  aliasProductType: string;
  handleClickEdit: () => void;
}

const messageStatus = {
  successful: 'Activa',
  error: 'Inactiva',
  pending: 'Vencida',
};

export const ItemProduct = ({
  userProductIdPublic,
  products,
  productId,
  productTitle,
  price,
  status,
  quantity,
  customerStripeId,
  providerProcessor,
  aliasProductType,
  handleClickEdit,
}: ItemProductProps) => {
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const getChips = (alias: string) => {
    if (!alias) return { typePrice: null, typeProduct: null };
    const [typePrice, typeProduct] = alias.toUpperCase().split(',');
    return { typePrice, typeProduct: typeProduct || null };
  };

  const copyToClipboard = async (id: string) => {
    try {
      await navigator.clipboard.writeText(id);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  // Note: This function is temporary, remove when handle edit for addons
  const isAddon = (products: ProductsDetailsView[]) => {
    return products.some((product) => product.isAddon);
  };

  const { typePrice, typeProduct } = getChips(aliasProductType);

  return (
    <div className="item__product__container">
      <Card>
        <div className="item__product__content">
          <div className="item__product__title">
            <span className="title--bold row">
              <span>{productTitle}</span>
            </span>
            {providerProcessor.toLocaleLowerCase() === 'stripe' && (
              <div className="item__product__more__options">
                {!isAddon(products) && (
                  <ButtonMoreOptions
                    id={productId}
                    testid={`test_${productId}`}
                    onClickEdit={handleClickEdit}
                  />
                )}
              </div>
            )}
          </div>
          <div className="product-id">
            <span className="product-id__label">ID:</span>
            <span className="product-id__value">{userProductIdPublic}</span>
            <button
              className="product-id__button"
              onClick={() => copyToClipboard(userProductIdPublic)}
            >
              {copiedId === userProductIdPublic ? (
                <Check className="icon-check" />
              ) : (
                <Copy className="icon-copy" />
              )}
            </button>
          </div>
          <div className="item__product__detail">{`Precio $${price}`}</div>
          <div className="item__product__status">
            <div className="item__product__chips-left">
              {typePrice && <Chips label={`# ${quantity} ${typePrice}`} />}
              {typeProduct && <Chips label={typeProduct} />}
            </div>
            <div className="item__product__chips-right">
              <div className="item__product__icon-pasarela">
                <PaymentGatewayLink
                  customerStripeId={customerStripeId}
                  providerProcessor={providerProcessor}
                />
              </div>
              <ItemStatus
                status={status}
                message={messageStatus[status]}
              ></ItemStatus>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
